import { fetchAttachmentObjectUrl } from "../api";
import { fetchBlobFromUrl } from "../api/person/person-attachment";

/**
 * Anchor-click a blob: object URL to trigger a browser download/open. Using an
 * anchor (not window.open) keeps it out of popup-blocker territory after await.
 */
function anchorDownload(objectUrl: string, name: string): void {
	const anchor = document.createElement("a");
	anchor.href = objectUrl;
	anchor.download = name;
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
	setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
}

/** Download a person attachment by id (private bucket → fetch with auth). */
export const triggerAttachmentDownload = async (
	id: number,
	name: string
): Promise<void> => {
	anchorDownload(await fetchAttachmentObjectUrl(id), name);
};

/** Download in-memory text as a file (markdown documents, CSV exports, etc.). */
export const triggerTextDownload = (
	text: string,
	name: string,
	mimeType: string
): void => {
	anchorDownload(URL.createObjectURL(new Blob([text], { type: mimeType })), name);
};

/** Download from any authenticated download URL (CV browser, etc.). */
export const triggerDownloadFromUrl = async (
	url: string,
	name: string
): Promise<void> => {
	const { blob } = await fetchBlobFromUrl(url);
	anchorDownload(URL.createObjectURL(blob), name);
};
